import { Factory } from 'fishery';
import {
  createFlexibleMonthlyPaymentPlan,
  paymentDetailsFactory,
} from '../GetPaymentDetails/factory';
import { RateType } from './types';

export const getRateResponseFactory = Factory.define<RateType>(() => {
  return {
    identifier: 'id',
    totalPremium: '1234.56',
    monthlyPremium: '123.45',
    pdfDownloadURL: 'document.pdf',
    underwritingPassed: true,
    paymentDetails: paymentDetailsFactory.build()['paymentDetails'],
  };
});

export const rateResponseWithPPFFactory = Factory.define<RateType>(() => {
  const rateBase = getRateResponseFactory.build();

  return {
    ...rateBase,
    paymentDetails: {
      ...rateBase.paymentDetails,
      attributes: {
        ...rateBase.paymentDetails.attributes,
        paymentPlans: [createFlexibleMonthlyPaymentPlan()],
      },
    },
  };
});
